import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import type { ItemBlock } from '@ps/web-martech-cms-types/Carousel';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import ColumnLayout from './ColumnLayout/ColumnLayout';
import styles from './ProspectHomepageCarousel.scss';
import SliderLayout from './SliderLayout/SliderLayout';

interface Props {
  autoRotate: boolean;
  slides: ItemBlock[];
  slideSpeed: number;
  withHeading: boolean;
}

const ProspectHomepageCarousel: React.FC<Props> = ({
  autoRotate,
  slides,
  slideSpeed,
  withHeading
}) => {
  const cmsContent = useSelector(select.cms.getContent);
  const sportsNonAuth = useFeature(FeatureFlag.SportsNonAuth);
  const casinoNonAuth = useFeature(FeatureFlag.CasinoNonAuth);

  const displayVertical = (vertical?: string) => {
    switch (vertical) {
      case 'Casino':
        return casinoNonAuth;
      case 'Sports':
        return sportsNonAuth;
      default:
        return true;
    }
  };

  const slidesData = slides
    .filter((slide) => displayVertical(slide.item.vertical))
    .map((slide) => cmsContent[slide.item.reference[0].uid] as ProspectHomepageSlide);

  return (
    <section
      className={classNames(styles.wrapper, {
        [styles.oneSlide]: slidesData.length === 1,
        [styles.withHeading]: withHeading
      })}
    >
      <SliderLayout autoRotate={autoRotate} slides={slidesData} slideSpeed={slideSpeed} />
      <ColumnLayout slides={slidesData} />
    </section>
  );
};

export default ProspectHomepageCarousel;
